import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "locationLabel"]

  connect() {
    this.toggleLocationField()
  }

  change() {
    this.toggleLocationField()
  }

  toggleLocationField() {
    const locationTypeSelect = this.element.querySelector('select[name*="location_type"]')
    const locationField = this.locationTarget
    const locationLabel = this.locationLabelTarget

    if (locationTypeSelect && locationField) {
      const locationType = locationTypeSelect.value

      if (locationType === "remote") {
        locationField.disabled = true
        locationField.value = ""
        locationField.classList.add("bg-gray-100", "cursor-not-allowed")
        locationField.classList.remove("bg-white")

        if (locationLabel) {
          locationLabel.classList.add("text-gray-400")
          locationLabel.classList.remove("text-dk-teal")
        }
      } else {
        locationField.disabled = false
        locationField.classList.remove("bg-gray-100", "cursor-not-allowed")
        locationField.classList.add("bg-white")

        if (locationLabel) {
          locationLabel.classList.remove("text-gray-400")
          locationLabel.classList.add("text-dk-teal")
        }
      }
    }
  }
}
